import Generic from 'src/models/generic/Generic'
import Model, { encoders, ID } from 'src/models/model'
import OrderCollectionDisplayType from 'src/models/order-collection-display/OrderCollectionDisplayType'

export default class OrderCollectionDisplayClient extends Model {
  static name = 'OrderCollectionDisplayClient'

  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      orderCollectionDisplayType: {
        type: OrderCollectionDisplayType,
        encode: encoders.hasOne,
        reference: true,
        default: null
      }
    }

    this.queries = {
      currentOrderCollectionDisplayClient: {
        results: {
          orderCollectionDisplayClient: OrderCollectionDisplayClient
        }
      },
      collectionOrderSummaries: {
        results: {
          value: Generic
        }
      }
    }
  }
}
